import React from 'react';
import styles from './index.module.less';

export default function WhatView({ data }: { data: any }) {
  const title = data?.contentInfo?.['section-what1']?.title || '';
  const bodyText = data?.contentInfo?.['section-what1']?.bodyText || [];
  const imgPath = data?.contentInfo?.['section-what1']?.imgPath || '';

  return (
    <div className={styles.container}>
      {/* WhatView */}
      <div className={styles.contentWrapper} style={{ backgroundImage: `url(${imgPath})` }}>
        <h2 className={styles.title}>{title}</h2>
        {bodyText.map((text: string, index: number) => (
          <p key={index} className={styles.desc}>
            {text}
          </p>
        ))}
      </div>
    </div>
  );
}
